import m from "../../geodata/es2015/bangladeshHigh";
window.am4geodata_bangladeshHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bangladeshHigh.js
// module id = null
// module chunks = 